import React, { useState, useEffect } from "react";
import contactImg from "../assest/images/contact-us/cloud.webp";
import { useLocation } from "react-router-dom";
import Loader from "../component/loader.jsx";
import { Helmet } from "react-helmet-async";

function Term_Condition() {
  const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
  const [isLoading, setIsLoading] = useState(false);

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      <Helmet>
        <title>Terms & Conditions | Ladakh MotoDrive</title>

        <meta
          name="description"
          content="Check terms and conditions for Ladakh MotoDrive tour packages, bookings, cancellations and travel policies."
        />

        <link
          rel="canonical"
          href="https://ladakhmotodrive.com/terms-and-conditions"
        />
        {/* Open Graph */}
        <meta
          property="og:title"
          content="Terms & Conditions | Ladakh MotoDrive"
        />
        <meta
          property="og:description"
          content="Check terms and conditions for Ladakh MotoDrive tour packages, bookings, cancellations and travel policies."
        />
        <meta
          property="og:url"
          content="https://ladakhmotodrive.com/terms-and-conditions"
        />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Terms & Conditions | Ladakh MotoDrive"
        />
        <meta
          name="twitter:description"
          content="Check terms and conditions for Ladakh MotoDrive tour packages, bookings, cancellations and travel policies."
        />
      </Helmet>
      <div className="container-fulid">
        <div className="cloud-img">
          <div className="cloud-move">
            <img src={contactImg} alt="cloud" />
          </div>
        </div>

        <div className="page-banner page-banner1">
          <div className="main-title">
            <h3 className="breadcrumb-title">Terms & Conditions</h3>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <div className="privacy-wrapper">
          <div className="container">
            <div className="privacy-card">
              <h1 className="privacy-title">Terms & Conditions</h1>

              <p>
                Welcome to <strong>Ladakh Traveler</strong>. By booking our
                services or using our website, you agree to comply with the
                following terms and conditions. Please read them carefully
                before making any booking for bike rentals, car rentals, or
                Ladakh tour packages.
              </p>

              <h4>1. Booking Confirmation</h4>
              <p>
                All bookings for bike rentals, car rentals, or tour packages
                will only be confirmed after receiving the required advance
                payment. The remaining amount must be paid before the start of
                the trip or rental period.
              </p>

              <h4>2. Rental Requirements</h4>
              <ul>
                <li>
                  Valid driving license is mandatory for bike or car rentals.
                </li>
                <li>Customers must provide valid identity proof.</li>
                <li>
                  The renter is responsible for any traffic violations during
                  the rental period.
                </li>
              </ul>

              <h4>3. Security Deposit</h4>
              <p>
                A refundable security deposit may be required at the time of
                vehicle pickup. The deposit will be refunded after the vehicle
                is returned in proper condition.
              </p>

              <h4>4. Vehicle Responsibility</h4>
              <p>
                Customers are responsible for maintaining the rented vehicle in
                good condition. Any damage, accident, or misuse during the
                rental period will be the responsibility of the renter.
              </p>

              <h4>5. Tour Package Policy</h4>
              <p>
                Tour itineraries may change due to weather conditions, road
                closures, or government regulations in Ladakh. In such cases,
                Ladakh Traveler reserves the right to modify the itinerary for
                safety and operational reasons.
              </p>

              <h4>6. Cancellation Policy</h4>
              <ul>
                <li>
                  Cancellation made 15 days before travel date – partial refund
                  may apply.
                </li>
                <li>
                  Cancellation within 7 days of travel – limited or no refund.
                </li>
                <li>No refund for no-show or last-minute cancellation.</li>
              </ul>

              <h4>7. Liability</h4>
              <p>
                Ladakh Traveler will not be responsible for any personal injury,
                accident, loss of belongings, or unforeseen circumstances during
                the trip.
              </p>

              <h4>8. Travel Conditions</h4>
              <p>
                Ladakh is a high-altitude region. Travelers are advised to take
                necessary health precautions and follow safety instructions
                provided by the tour guides.
              </p>

              <h4>9. Changes to Terms</h4>
              <p>
                Ladakh Traveler reserves the right to update or modify these
                Terms & Conditions at any time without prior notice.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Term_Condition;
